import { keyframes } from '@mui/system'
import type { Keyframes } from '@emotion/react'

export const pulse: Keyframes = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`
